import * as SelectPrimitive from "@radix-ui/react-select";
import { ComponentProps } from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import t from "@/lang/lang";
import { useListBranchQuery } from "@/services/backend/branch/api/branch";
import { RefreshCw } from "lucide-react";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { NullUUID } from "@/shared/lib/utilities/uuid";
import { CompanyName } from "@/services/backend/company/components/company-name";

export function BranchSelect({
  companyId,
  showCompany = false,
  ...props
}: ComponentProps<typeof SelectPrimitive.Root> & {
  companyId?: string;
  showCompany?: boolean;
}) {
  const { data, isLoading, error } = useListBranchQuery({
    company: {
      active: companyId !== undefined,
      values: [companyId ?? NullUUID],
    },
  });

  return (
    <Select {...props}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder={t("Niederlassung auswählen")} />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {isLoading && (
            <SelectItem value="loading" disabled>
              <RefreshCw className="size-4" />
              <span>{t("Lade Niederlassungen")}</span>
            </SelectItem>
          )}
          {error && (
            <SelectItem value="error" disabled>
              <RTKQueryErrorAlert error={error} />
            </SelectItem>
          )}
          {data?.branches.map((branch) => (
            <SelectItem value={branch.id} key={branch.id}>
              <span>{branch.name}</span>
              {showCompany && (
                <span>
                  (<CompanyName companyId={branch.companyId} short />)
                </span>
              )}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
